<template>
    <div class="radio-select" :data-val="value">
        <div class="top">
            <span class="required" v-if="required">*</span>
            <div class="title" v-html="title"></div>
        </div>
        <template v-for="item in options">
            <template v-if="isDetails">
                <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option"  :desc="item.desc" :key="item.val" :active="value === item.val" v-if="isDetails && value == item.val"></SelectOption>
            </template>
            <template v-else>
                <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option"  :desc="item.desc" :key="item.val" :active="value === item.val"></SelectOption>
            </template>
            <div class="child" v-if="item.child && value == item.val">
                <div class="yes" v-if="item.child.name == 'MultiSelectAndInput' || item.child.name == 'RadioSelectAndInput' || item.child.name == 'InputOption'">
                    <component :isDetails="isDetails" :is='item.child.name'  v-bind="item.child.props" v-model="item.child.value"></component>
                </div>
                <div class="yes" v-else-if="item.child.name == 'InputOptions'">
                    <component :isDetails="isDetails" :is='item.child.name'  v-bind="item.child.props"></component>
                </div>
                <div v-else class="no">目前只支持MultiSelectAndInput、RadioSelectAndInput、InputOption、InputOptions</div>
            </div>
        </template>
    </div>
</template>
<script>
    import SelectOption from './Private/SelectOption.vue'
    import InputOption from './Private/InputOption.vue'
    import InputOptions from './Private/InputOptions.vue'
    import MultiSelectAndInput from './MultiSelectAndInput.vue'
    import RadioSelectAndInput from './RadioSelectAndInput.vue'

    export default {
        name: 'RadioSelect',
        props: {
            value:Number|String,
            title:String,
            required:Boolean,
            options: {
                type: Array,
                default:function () {
                    return []
                }
            },
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            selectOption(val){
                if(this.isDetails){return;}
                if(val == this.value){
                    this.$emit('input',null);
                    return
                }
                this.$emit('input',val)


            }
        },
        components:{SelectOption,RadioSelectAndInput,MultiSelectAndInput,InputOptions,InputOption}
    }
</script>
<style lang="scss" scoped>
    .radio-select{
        padding: 16px;
        .top{
            display: flex;
            align-items: center;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                font-size: 16px;
            }
        }
        .option{
            margin-top: 16px;
        }
        .child{
            margin-top: 16px;
        }
    }

</style>
